import { axios } from '@/utils/request'
export function getfindByMenuId (parameter) {
  return axios({
    url:  '/system/user/findByMenuId',
    method: 'get',
    params: parameter
  })
}
export function getsavetemplate (parameter) {
  return axios({
    url:  '/finance/statement/template/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}